var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Suggested Icon",
    clipPath: "url(#clip0_6335_7220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.000558036 8C0.000558036 3.58245 3.58245 0.000558036 8 0.000558036C12.4176 0.000558036 15.9994 3.58245 15.9994 8C15.9994 12.4176 12.4176 15.9994 8 15.9994C3.58245 15.9994 0.000558036 12.4176 0.000558036 8ZM1.35658 8C1.35658 11.6682 4.33184 14.6434 8 14.6434C11.6682 14.6434 14.6434 11.6682 14.6434 8C14.6434 4.33184 11.6682 1.35658 8 1.35658C4.33184 1.35658 1.35658 4.33184 1.35658 8ZM7.39402 5.46284C7.23338 5.3022 7.14314 5.08432 7.14314 4.85714C7.14314 4.62996 7.23338 4.41209 7.39402 4.25145C7.55467 4.09081 7.77254 4.00056 7.99972 4.00056C8.2269 4.00056 8.44478 4.09081 8.60542 4.25145C8.76606 4.41209 8.85631 4.62996 8.85631 4.85714C8.85631 5.08432 8.76606 5.3022 8.60542 5.46284C8.44478 5.62348 8.2269 5.71373 7.99972 5.71373C7.77254 5.71373 7.55467 5.62348 7.39402 5.46284ZM7.42885 7C7.42885 6.92174 7.49289 6.8577 7.57115 6.8577H8.42829C8.50656 6.8577 8.57059 6.92174 8.57059 7V11.8571C8.57059 11.9354 8.50656 11.9994 8.42829 11.9994H7.57115C7.49289 11.9994 7.42885 11.9354 7.42885 11.8571V7Z",
    fill: "#D1D1D1",
    stroke: "#D1D1D1",
    strokeWidth: 0.00111607
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6335_7220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e9934730033cf62f21694e468025559e.svg";
export { ForwardRef as ReactComponent };